import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async"; // HelmetProvider 임포트
import MainPage from "./components/MainPage";
import ArtworkPage from "./components/Artwork";
import ContactsPage from "./components/Contacts";
import BiographyPage from "./components/Biography";
import LanguageProvider from "./components/providers/LanguageProvider";

function App() {
  return (
    <HelmetProvider>
      {" "}
      {/* 최상위 Provider로 감싸기 */}
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/artwork" element={<ArtworkPage />} />
            <Route path="/biography" element={<BiographyPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
